"use strict";

exports.__esModule = true;
var _CreateTicketDialog = require("./CreateTicketDialog");
Object.keys(_CreateTicketDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateTicketDialog[key]) return;
  exports[key] = _CreateTicketDialog[key];
});